import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Product} from '../model/Entities/Product';
import {Observable} from 'rxjs/Observable';
import {User} from '../model/Entities/User';
import {Filter} from '../model/Helpers/Filter';
import {Contract} from '../model/Entities/Contract';
import {ProductType} from '../model/Entities/ProductType';
import {ProductContent} from '../model/Entities/ProductContent';

@Injectable()
export class ProductService extends ApiService<Product> {

    protected apiUrl = 'api/products';  // URL to web api

    protected getObjectType(): any {
        return Product;
    }

    get(id: Number, params: Object = {}): Observable<Product> {
        return super.get(id, params)
            .do((p: Product) => {
                if (!p.content) {
                    p.content = [];
                }
            });
    }

    getSimpleList(filters: Filter[] = [], params: Object = {}): Observable<Product[]> {
        return super.getSimpleList(filters, params).map((data) => {
            data = this.mapItemsExpand(data);
            return data;
        });
    }

    private mapItemsExpand(data: Product[]) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].type === ProductType.group) {
                data[i].content = this.expandGroupContent(data[i].content);
            }
        }

        return data;
    }

    private expandGroupContent(items: ProductContent[]) {
        for (let i = 0; i < items.length; i++) {
            items[i].content = this.objectResponseToCamelCase(items[i].content);
        }

        return items;
    }
}



// WEBPACK FOOTER //
// /app/src/services/product.service.ts